module.exports = __webpack_public_path__ + "img/Cancel-icon.5bd0c1c8.svg";